import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd';

@Component({
  selector: 'app-dialog-modal',
  templateUrl: './dialog-modal.component.html',
  styleUrls: ['./dialog-modal.component.scss']
})
export class DialogModalComponent {
  tplModal: NzModalRef;
  exibirConteundoExterno = false;

  @Input() title?: string;
  @Input() subtitle?: string;
  @Input() subtitle2?: string;

  @ViewChild('tplContent', { static: true })
  tplContent: TemplateRef<{}>;

  @ViewChild('tplFooter', { static: true })
  tplFooter: TemplateRef<{}>;

  constructor(private modalService: NzModalService) {}

  createTplModal(title: string, subtitle: string, subtitle2?: string): void {
    this.title = title;
    this.subtitle = subtitle;
    this.subtitle2 = subtitle2;
    this.tplModal = this.modalService.create({
      nzContent: this.tplContent,
      nzFooter: this.tplFooter,
      nzClosable: false,
      nzWidth: 650,
      nzMaskClosable: false,
      nzOnCancel: () => {},
      nzOnOk: () => {}
    });
  }

  createTplModalContent(content: TemplateRef<{}>): void {
    this.tplModal = this.modalService.create({
      nzContent: content,
      nzFooter: this.tplFooter,
      nzClosable: false,
      nzWidth: 650,
      nzMaskClosable: false,
      nzOnCancel: () => {},
      nzOnOk: () => {}
    });
  }

  destroyTplModal(): void {
    this.tplModal.destroy();
  }
}
